export default __webpack_public_path__ + "static/media/omnichannel.47e8285c.jpg";